import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.small`
  color: ${Colours.greyLight3};
`;
